/** @flow */
import React from 'react';
// import type { Element } from 'react';


export default function displayNewLines(value) {
  // eslint-disable-next-line react/no-array-index-key
  return value.split('\n').filter(l => !!l).map((line, index) => <div key={index}>{line}</div>);
}
